import { design_systemUiEventEventSchemaV1 } from './__generated__';
import { trackSelfDescribingEventTypeSafe } from './typesafe-self-describing-event-tracker';
export const TRACKING_DATA_ATTRIBUTE = 'data-tracking-id';
export const getIdFromHTMLEvent = (e) => {
    if (e.currentTarget instanceof HTMLElement) {
        const trackingId = e.currentTarget.getAttribute(TRACKING_DATA_ATTRIBUTE);
        if (trackingId) {
            return trackingId;
        }
        if (e.currentTarget.id) {
            return e.currentTarget.id;
        }
    }
    return undefined;
};
export const emitUIEvent = (event, contexts) => {
    const { component_name, event_name, id, value, context_id } = event;
    trackSelfDescribingEventTypeSafe({
        event: {
            schema: design_systemUiEventEventSchemaV1,
            data: {
                component_name,
                event_name,
                value,
                id,
                context_id
            }
        },
        context: contexts ?? []
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidWktZXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL3VpLWV2ZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBLE9BQU8sRUFBRSxpQ0FBaUMsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBQ3BFLE9BQU8sRUFBRSxnQ0FBZ0MsRUFBRSxNQUFNLDBDQUEwQyxDQUFDO0FBRTVGLE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLGtCQUFrQixDQUFDO0FBRTFELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLENBQUMsQ0FBdUIsRUFBc0IsRUFBRTtJQUNoRixJQUFJLENBQUMsQ0FBQyxhQUFhLFlBQVksV0FBVyxFQUFFLENBQUM7UUFDM0MsTUFBTSxVQUFVLEdBQUcsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsdUJBQXVCLENBQUMsQ0FBQztRQUN6RSxJQUFJLFVBQVUsRUFBRSxDQUFDO1lBQ2YsT0FBTyxVQUFVLENBQUM7UUFDcEIsQ0FBQztRQUNELElBQUksQ0FBQyxDQUFDLGFBQWEsQ0FBQyxFQUFFLEVBQUUsQ0FBQztZQUN2QixPQUFPLENBQUMsQ0FBQyxhQUFhLENBQUMsRUFBRSxDQUFDO1FBQzVCLENBQUM7SUFDSCxDQUFDO0lBQ0QsT0FBTyxTQUFTLENBQUM7QUFDbkIsQ0FBQyxDQUFDO0FBSUYsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLENBQUMsS0FBc0MsRUFBRSxRQUFtQixFQUFFLEVBQUU7SUFDekYsTUFBTSxFQUFFLGNBQWMsRUFBRSxVQUFVLEVBQUUsRUFBRSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDcEUsZ0NBQWdDLENBQUM7UUFDL0IsS0FBSyxFQUFFO1lBQ0wsTUFBTSxFQUFFLGlDQUFpQztZQUN6QyxJQUFJLEVBQUU7Z0JBQ0osY0FBYztnQkFDZCxVQUFVO2dCQUNWLEtBQUs7Z0JBQ0wsRUFBRTtnQkFDRixVQUFVO2FBQ1g7U0FDRjtRQUNELE9BQU8sRUFBRSxRQUFRLElBQUksRUFBRTtLQUN4QixDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==